
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/itsolutions/microsoftoffice",
      function () {
        return require("private-next-pages/itsolutions/microsoftoffice.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/itsolutions/microsoftoffice"])
      });
    }
  